module.exports = __webpack_public_path__ + "assets/img/11fa74c2b1b045f6cf07ccab1e2ba87c.svg";